import * as z from "zod";

export const getWithdrawalsOnboardingSettings = {
  name: "getWithdrawalsOnboardingSettings" as const,
  input: z.object({}),
  output: z.object({
    settings: z.object({
      billingReady: z.boolean(),
      chargeAmount: z.string(),
      chargeShipping: z.boolean(),
      chargeType: z.enum(["actual", "flat"]),
      enableThirdPartyFulfillmentCancellationEmail: z.boolean(),
      merchantNotificationEmails: z.array(z.string()),
      returnAddress: z.string().optional(),
      thirdPartyFulfillmentCancellationEmails: z.array(z.string()),
    }),
  }),
};
